<template>
    <nav class="publication-child-nav scrollbar-hide" aria-label="Типи публікацій">
        <router-link class="publication-child-tab" :to="`/u/${profile.username}/reviews`">
            Рецензії та відгуки <span class="publication-child-count">· {{ publicationCounts.reviews }}</span>
        </router-link>
        <router-link class="publication-child-tab" :to="`/u/${profile.username}/discussions`">
            Дискусії <span class="publication-child-count">· {{ publicationCounts.discussions }}</span>
        </router-link>
        <router-link class="publication-child-tab" :to="`/u/${profile.username}/quotes`">
            Цитати <span class="publication-child-count">· {{ publicationCounts.quotes }}</span>
        </router-link>
        <router-link class="publication-child-tab" :to="`/u/${profile.username}/facts`">
            Факти <span class="publication-child-count">· {{ publicationCounts.facts }}</span>
        </router-link>
    </nav>
</template>

<script lang="js">
export default {
    name: 'PublicationsNav',
    props: {
        profile: { type: Object, required: true },
        dashboard: { type: Object, default: null },
    },
    mounted() {
        this.$nextTick(this.revealActiveTab);
        window.addEventListener('resize', this.revealActiveTab);
    },
    beforeDestroy() { window.removeEventListener('resize', this.revealActiveTab); },
    methods: {
        revealActiveTab() {
            const nav = this.$el;
            const active = nav?.querySelector('.router-link-exact-active');
            if (!active) return;
            const bounds = nav.getBoundingClientRect();
            const tab = active.getBoundingClientRect();
            if (tab.right > bounds.right) nav.scrollLeft += tab.right - bounds.right;
            else if (tab.left < bounds.left) nav.scrollLeft += tab.left - bounds.left;
        },
    },
    computed: {
        publicationCounts() {
            const stats = this.dashboard?.stats || {};
            return {
                reviews: Number(stats.reviews_count || 0),
                discussions: Number(stats.discussions_count || 0),
                quotes: Number(stats.quotes_count || 0),
                facts: Number(stats.facts_count || 0),
            };
        },
    },
};
</script>
